// Real, multi-slide template decks — the catalogue behind the Templates page.
// Each is a complete, typed SlideDeck (not a prompt), so the page can show a
// live cover thumbnail, a full navigable preview, and "use" = clone into a real
// editable deck. The narratives are believable end to end (the Workplace by
// Ricoh pitch carries real platform figures) so they double as training data.
import type { SlideDeck } from './slide-model';
import { wbrPitchDeck } from './templates/wbr-pitch';
import { qbrDeck } from './templates/qbr';
import { productLaunchDeck } from './templates/product-launch';
import { projectKickoffDeck } from './templates/project-kickoff';
import { sampleDeck } from './sample-deck';

export type TemplateCategory = 'Board' | 'Sales' | 'Product' | 'Internal';

export interface DeckTemplate {
  id: string;
  name: string;
  category: TemplateCategory;
  blurb: string;
  deck: SlideDeck;
}

export const TEMPLATE_DECKS: DeckTemplate[] = [
  { id: 'wbr-pitch', name: 'Workplace by Ricoh pitch', category: 'Sales',
    blurb: 'Problem, platform, proof, pricing and the ask.', deck: wbrPitchDeck },
  { id: 'qbr', name: 'Quarterly business review', category: 'Board',
    blurb: 'KPIs, the trend, wins, risks and next quarter.', deck: qbrDeck },
  { id: 'product-launch', name: 'Product launch', category: 'Product',
    blurb: 'Vision, the headline features, proof and availability.', deck: productLaunchDeck },
  { id: 'project-kickoff', name: 'Project kickoff', category: 'Sales',
    blurb: 'Context, scope, the plan, the team and investment.', deck: projectKickoffDeck },
  { id: 'board-review', name: 'Board review', category: 'Board',
    blurb: 'Traction, metrics and the ask.', deck: sampleDeck },
];

export function templateById(id: string): DeckTemplate | undefined {
  return TEMPLATE_DECKS.find((t) => t.id === id);
}
